// extracted by css-extract-rspack-plugin
export default {"arrow":"_f934c381","isLeft":"_ab12ad19"};